<section id="app-showcase">
  <div class="container">
    <!-- Header -->
    <div class="showcase-header text-center" appAnimateOnScroll="fade-in-up">
      <img src="assets/images/logo_ctc_network.png" alt="CTC Network App Logo" class="logo">
      <h1>
        {{ 'showcase.TITLE' | translate }} <span class="app-name">{{ 'showcase.APP_NAME' | translate }}</span>
      </h1>
      <div class="store-buttons">
        <a href="#" class="store-button">
          <img src="assets/images/googleplay.png" alt="Get it on Google Play">
          <div>
            <span>{{ 'showcase.DOWNLOAD_ON' | translate }}</span>
            <strong>Google Play</strong>
          </div>
        </a>
        <a href="#" class="store-button">
          <img src="assets/images/appstore.png" alt="Download on the App Store">
          <div>
            <span>{{ 'showcase.DOWNLOAD_ON' | translate }}</span>
            <strong>App Store</strong>
          </div>
        </a>
      </div>
    </div>

    <!-- Features Grid -->
    <div class="row align-items-center showcase-grid">
      <!-- Left Column -->
      <div class="col-lg-4 feature-col">
        @for (feature of features.slice(0, 3); track feature) {
          <div class="feature-card" appAnimateOnScroll="fade-in-left">
            <div class="feature-card-header">
              <div class="feature-icon-wrapper">
                <img [src]="feature.icon" [alt]="('showcase.FEATURES.' + feature.key + '.TITLE' | translate) + ' icon'" class="feature-icon">
              </div>
              <h3 class="feature-title">{{ 'showcase.FEATURES.' + feature.key + '.TITLE' | translate }}</h3>
            </div>
            <p class="feature-desc">{{ 'showcase.FEATURES.' + feature.key + '.DESCRIPTION' | translate }}</p>
          </div>
        }
      </div>

      <!-- Center Column (Image) -->
      <div class="col-lg-4 my-4 my-lg-0 image-col" appAnimateOnScroll="fade-in">
        <img src="assets/images/app-screen.png" alt="App Screenshot" class="app-image">
      </div>

      <!-- Right Column -->
      <div class="col-lg-4 feature-col">
        @for (feature of features.slice(3, 6); track feature) {
          <div class="feature-card" appAnimateOnScroll="fade-in-right">
            <div class="feature-card-header">
              <div class="feature-icon-wrapper">
                <img [src]="feature.icon" [alt]="('showcase.FEATURES.' + feature.key + '.TITLE' | translate) + ' icon'" class="feature-icon">
              </div>
              <h3 class="feature-title">{{ 'showcase.FEATURES.' + feature.key + '.TITLE' | translate }}</h3>
            </div>
            <p class="feature-desc">{{ 'showcase.FEATURES.' + feature.key + '.DESCRIPTION' | translate }}</p>
          </div>
        }
      </div>
    </div>
  </div>
</section>